import HeaderForClient from './HeaderForClient';

export default HeaderForClient;